import { Injectable } from '@angular/core';
import * as THREE from 'three';
import { WorkbenchSelectionStore } from '../../../../../stores/workbench/workbench-selection.store';

@Injectable({
  providedIn: 'root'
})
export class WorkbenchRaycasterService {
  private readonly raycaster: THREE.Raycaster;
  private readonly pointer: THREE.Vector2;
  private camera: THREE.Camera | null = null;
  private scene: THREE.Scene | null = null;
  private container: HTMLElement | null = null;

  constructor(private readonly store: WorkbenchSelectionStore) {
    this.raycaster = new THREE.Raycaster();
    this.pointer = new THREE.Vector2();
  }

  public initialize(container: HTMLElement, camera: THREE.Camera, scene: THREE.Scene) {
    this.container = container;
    this.camera = camera;
    this.scene = scene;
  }

  public updatePointer(event: PointerEvent) {
    if (!this.container) return;

    const rect = this.container.getBoundingClientRect();
    this.pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    this.store.setPointer(this.pointer);
  }

  public performRaycast() {
    if (!this.camera || !this.scene) return;

    this.raycaster.setFromCamera(this.pointer, this.camera);

    // We want to intersect everything, let the Manager filter logic/physics
    // Note: intersectObjects(recursive=true)
    const intersects = this.raycaster.intersectObjects(this.scene.children, true);

    this.store.setIntersections(intersects);
  }

  // Helper for specific raycasts (e.g. dropping checks)
  public castRay(origin: THREE.Vector3, direction: THREE.Vector3, objects: THREE.Object3D[]): THREE.Intersection[] {
    this.raycaster.set(origin, direction);
    return this.raycaster.intersectObjects(objects, true);
  }

  public getRaycaster(): THREE.Raycaster {
    return this.raycaster;
  }
}
